<div
  class="overlay"
  [ngStyle]="{ 'z-index': 1110 }"
  *ngIf="loader.loading$ | async">
  <desy-spinner></desy-spinner>
</div>
